import { codeWords } from './api'

// A stored value reaching a report table, in the words a person reads.
//
// Release 3.2 (found walking the CPO's flows): the vendor master report showed
// ACTIVE, DRAFT, HIGH and CRITICAL in capitals beside "Pending approval" in
// words, because the rule below was deliberately narrow: only values with an
// underscore were turned into words, so that a PAN, a vendor code or a date is
// never touched. A single-word code in a column that is known to hold states
// (the band, the status, the severity) is safe to turn into words, because
// nothing else lives in those columns.
//
// The CSV is built by the server and is not affected: the file still carries
// the codes, because a file is read by another program.
const ENUM_CELL = /^[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+$/
const SINGLE_WORD_CODE = /^[A-Z][A-Z0-9]+$/

// The report columns whose cells are states and ratings and nothing else.
const STATE_COLUMNS = new Set([
  'risk', 'band', 'status', 'state', 'severity', 'result', 'kind', 'rating', 'riskband', 'finalband',
])

export function cellWords(cell: string, column?: string): string {
  if (ENUM_CELL.test(cell)) return codeWords(cell)
  if (column && STATE_COLUMNS.has(column.toLowerCase()) && SINGLE_WORD_CODE.test(cell)) return codeWords(cell)
  return cell
}
